import React, { useCallback, useRef, useState } from "react";
import * as Scrivito from "scrivito";
import { TabContent, TabPane } from "reactstrap";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";

import { ZoomControls } from "objs/_ConfiguratorObjs/Wizard/SubComponents/WizardResult/ZoomControls";
import { TopologySummary } from "objs/_ConfiguratorObjs/Wizard/SubComponents/WizardResult/ToplogySummary/TopologySummary";
import { Topology } from "components/Topology/Topology";
import {
  useStructuredTopology,
  useSubType,
  useWizardActions,
  useWizardResultTab,
} from "objs/_ConfiguratorObjs/Wizard/stores/wizardStore";
import { useCenterTopologyItem } from "hooks/wizardHooks/useCenterTopologyItem";

import { TopologyTopBar } from "./WizardResult/TopologyTopBar/TopologyTopBar";

export const WizardResult = Scrivito.connect(() => {
  const currentPage = Scrivito.currentPage();

  const transformRef = useRef(null);
  const viewportRef = useRef(null);

  const { setCenterTopologyItemId } = useWizardActions();
  const wizardResultTab = useWizardResultTab();
  const structuredTopology = useStructuredTopology();
  const subType = useSubType();

  const [transformState, setTransformState] = useState({
    scale: 1,
    positionX: 0,
    positionY: 0,
  });

  const handleTransform = useCallback(
    (event) => {
      const { scale, positionX, positionY } = event.state;
      setTransformState({ scale, positionX, positionY });
      setCenterTopologyItemId(); // reset center item after manual move
    },
    [setCenterTopologyItemId],
  );

  useCenterTopologyItem({
    transformRef,
    viewportRef,
  });

  return (
    <TabContent activeTab={wizardResultTab} className="w-100">
      <TopologyTopBar />
      {wizardResultTab === "topology" && (
        <TabPane
          tabId="topology"
          id="transformComponent"
          className="position-absolute w-100 h-100"
        >
          <div
            className="position-relative w-100 h-100 overflow-hidden"
            ref={viewportRef}
          >
            <TransformWrapper
              minScale={0.02}
              maxScale={3}
              wheel={{ step: 0.04 }}
              initialPositionY={-120}
              onTransformed={handleTransform}
              ref={transformRef}
              panning={{ activationKeys: [], excluded: ["panzoomDisabled"] }}
              pinch={{ excluded: ["panzoomDisabled"] }}
              doubleClick={{ excluded: ["panzoomDisabled"] }}
            >
              {(panzoomProps) => (
                <>
                  <TransformComponent
                    wrapperClass="mh-100 mw-100 w-100 overflow-hidden position-absolute"
                    contentClass=""
                    contentStyle={{
                      paddingLeft: "12.5%",
                      paddingRight: "12.5%",
                      paddingBottom: "300px",
                      paddingTop: "300px",
                    }}
                  >
                    <Topology
                      transformState={transformState}
                      viewportRef={viewportRef}
                      transformRef={transformRef}
                    />
                  </TransformComponent>

                  <ZoomControls
                    {...panzoomProps}
                    scale={transformState.scale}
                  />
                </>
              )}
            </TransformWrapper>
          </div>

          {subType === "fireprotection" && (
            <Scrivito.ContentTag
              content={currentPage}
              attribute="fireprotectionPopup"
              tag="div"
            />
          )}
        </TabPane>
      )}

      {wizardResultTab === "summary" && (
        <TabPane tabId="summary">
          <TopologySummary {...structuredTopology} />
        </TabPane>
      )}
    </TabContent>
  );
});
